/**
 * Used for all custom styled components
 * for rate card layouts
 */

import styled from "styled-components";
import { Form, DatePicker, Select, Typography, InputNumber, Button } from "antd";
import colors from "css/colors";

const { Text } = Typography;
const { Option } = Select;

export const StyledDangerButton = styled(Button)`
  border-radius: 6px;
  text-transform: uppercase;
`;

export const StyledButton = styled(Button)`
  border-radius: 6px;
  background-color: ${colors.BLUE};
  text-transform: uppercase;
`;

export const StyledLabel = styled(Text)`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.GREY_DARK};
`;

export const StyledDatePicker = styled(DatePicker)`
  height: auto;
  width: 100%;
  cursor: pointer;

  input::placeholder {
    color: ${colors.CHARCOAL};
  }
`;

export const StyledCustomSelect = styled(Select)`
  .ant-form-item &.ant-select {
    height: auto;
    cursor: pointer;
  }

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    border-color: ${colors.BLUE};
    color: ${colors.BLUE};
  }
`;

export const StyledOption = styled(Option)`
  color: ${colors.BLUE};
`;

export const StyledDisabledInput = styled("div")`
  width: auto;
  min-width: 200px;
  background: ${colors.GREY_LIGHT};
  height: 32px;
  padding: 4px 16px;
  display: flex;
  align-items: center;
`;

export const StyledInputNumber = styled(InputNumber)`
  color: ${colors.CHARCOAL};

  input {
    text-align: right;
  }

  .ant-input-number-handler-wrap {
    display: none;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  .ant-form-item-label > label {
    font-size: 12px;
    line-height: 16px;
    color: ${colors.GREY_DARK};
    font-weight: normal;
  }
`;

export const StyledFormLabel = styled.label`
  font-family: "Open Sans", sans-serif;
  pointer-events: auto;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  white-space: nowrap;
  text-align: left;
  touch-action: manipulation;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 32px;
  font-size: 12px;
  line-height: 16px;
  color: #828282;
  font-weight: normal;
  margin-bottom: 0;
`;

export const FormItemSpaceBetween = styled(Form.Item)`
  &.ant-form-item {
    width: 100%;
    justify-content: space-between;

    .ant-form-item-control {
      flex: 0;
    }
  }
`;
